var _g, _g2, _g3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconMfa = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "white",
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 491.52 491.52",
    xmlSpace: "preserve",
    stroke: "white",
    strokeWidth: 10.321919999999999,
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_bgCarrier",
    strokeWidth: 0
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_tracerCarrier",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    id: "SVGRepo_iconCarrier"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M460.8,317.44v-30.72c0-39.525-32.155-71.68-71.68-71.68c-11.003,0-21.394,2.565-30.72,7.014 c-6.325-3.441-12.906-6.425-19.865-8.509l-17.205-5.085l-75.57,75.57l-75.57-75.57l-17.25,5.095 c-9.338,2.802-17.984,6.845-25.896,11.819l-39.289-39.289L71.08,191.01C28.565,203.765,0,242.155,0,286.54v82.1h78.51v30.72 h208.21v61.44h204.8V317.44H460.8z M389.12,235.52c28.23,0,51.2,22.97,51.2,51.2v30.72h-102.4v-30.72 C337.92,258.49,360.89,235.52,389.12,235.52z M78.51,348.16H20.48v-61.62c0-35.27,22.7-65.78,56.44-75.9l4.965-1.465 l28.841,28.841C90.569,257.199,78.51,284.123,78.51,313.6V348.16z M286.72,378.88H98.99V313.6 c0-37.365,24.045-69.69,59.795-80.415l5.535-1.635l81.44,81.44l81.44-81.44l5.495,1.625c2.166,0.649,4.234,1.545,6.335,2.363 c-13.302,13.021-21.59,31.142-21.59,51.182v30.72h-30.72V378.88z M471.04,440.32H307.2v-102.4h163.84V440.32z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 348.16,
    y: 358.4,
    width: 102.4,
    height: 20.48
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 368.64,
    y: 399.36,
    width: 61.44,
    height: 20.48
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M245.76,44.85c-12.551,0-24.37,3.186-34.699,8.786C197.906,39.173,179.259,30.72,159.4,30.72 c-38.545,0-69.9,31.36-69.9,69.905s31.355,69.905,69.9,69.905c10.352,0,20.452-2.284,29.694-6.629 c13.404,16.479,33.818,27.039,56.666,27.039c40.275,0,73.045-32.77,73.045-73.045C318.805,77.62,286.035,44.85,245.76,44.85z M178.411,146.153c-5.992,2.502-12.414,3.897-19.011,3.897c-27.25,0-49.42-22.17-49.42-49.425S132.15,51.2,159.4,51.2 c13.342,0,25.886,5.434,35.091,14.745c-13.427,13.253-21.776,31.639-21.776,51.95 C172.715,127.909,174.747,137.455,178.411,146.153z M245.76,170.46c-28.985,0-52.565-23.58-52.565-52.565 s23.58-52.565,52.565-52.565s52.565,23.58,52.565,52.565S274.745,170.46,245.76,170.46z"
  }))))));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconMfa);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon_mfa.40fc31326becb93b07f4e2b2436fb4f7.svg";